import LoaderSpiner from "../../../../components/loaderSpiner";
import React, { useState, useRef } from "react";
import Dropdown from "../../../../components/Dropdown";
import { useNavigate } from "react-router-dom";
import UpdatePopup from "./UpdatePopup";
import { useBlockPackingMutation, useDeletePackingListMutation, useDuplicatePackingMutation, usePackingStatusMutation } from "../../../../services/Api";
import { toast } from "react-toastify";
import { blockPackingThunk, deletePackingThunk } from "../../../../redux/slices/packingSlice";
import { useDispatch } from "react-redux";
import Cropper from "react-cropper";

export default function PackingTable({ loading, data, trigger }) {
  const [dropdownActive, setDropdownActive] = useState(null);
  // const [isUpdateModalOpen, setIsUpdateModalOpen] = useState(false);
  // const [selectedItem, setSelectedItem] = useState(null);
  // const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  // const [selectedDeleteItem, setSelectedDeleteItem] = useState(null);
  const [blockPacking, { isLoading, isError, isSuccess }] = useBlockPackingMutation();
  const [duplicatePacking] = useDuplicatePackingMutation();
  const [packingStatus] = usePackingStatusMutation();
  const [deletePackingList, { isLoading: isLoadingDelete, isError: isErrorDelete, isSuccess: isSuccessDelete }] = useDeletePackingListMutation();
  const [packingList, setPackingList] = useState({
    isUpdateModalOpen: false,
    selectedItem: null,
    isDeleteModalOpen: false,
    selectedDeleteItem: null,
  });
  console.log("data in packing table", data?.data)
  // Example of updating state
  const updateListState = (newState) => {
    setPackingList((prevState) => ({ ...prevState, ...newState }));
  };

  const handleBlockPacking = async (id, duration = "6months") => {
    try {
      const response = await blockPacking({ id, blockDuration: duration });
      toast.success("Packing List Blocked Successfully");
      trigger();
    } catch (error) {
    }
  };
  const handleStatusPacking = async (id, status) => {
    const formData = {
      status: status
    }
    try {
      const response = await packingStatus({ data: formData, id: id });
      toast.success("Packing List Status Updated Successfully");
      trigger();
    } catch (error) {
    }
  };
  const handleDuplicatePacking = async (id) => {
    try {
      const response = await duplicatePacking({ id });
      toast.success("Duplicate Packing List Successfully");
      trigger();
    } catch (error) {
      console.log(error)
    }
  };
  const handleDeletePacking = async (id) => {
    try {
      const response = await deletePackingList({ id });
      toast.success("Packing List Deleted Successfully");
      updateListState({ isDeleteModalOpen: false, selectedDeleteItem: null });
      trigger();
    } catch (error) {
    }
  };

  const navigate = useNavigate();
  const toggleDropdown = (index) => {
    setDropdownActive((prev) => (prev === index ? null : index));
  };

  const closeUpdatePopup = () => {
    updateListState({ isUpdateModalOpen: false, selectedItem: null });
  };


  const closeDeletePopup = () => {
    updateListState({ isDeleteModalOpen: false, selectedDeleteItem: null });

  };


  return (
    <div>
      <table className="w-full table-auto border-separate border-spacing-y-4">
        <thead>
          <tr className="bg-tablecolor">
            <th className="p-3 text-center align-middle w-8 rounded-l-xl border-l border-t border-b border-solid border-bordercolor">
              <input type="checkbox" className="rounded border-gray-300" />
            </th>
            <th className="p-3 text-center align-middle text-black text-sm font-['Roboto_Mono'] text-[14px] font-medium border-t border-b border-solid border-bordercolor">
              ID
            </th>
            <th className="p-3 text-center align-middle text-black text-sm font-['Roboto_Mono'] text-[14px] font-medium border-t border-b border-solid border-bordercolor">
              Title
            </th>
            <th className="p-3 text-center align-middle text-black font-['Roboto_Mono'] text-[14px] font-medium text-sm border-t border-b border-solid border-bordercolor">
              Type
            </th>
            <th className="p-3 whitespace-nowrap text-center align-middle text-black font-['Roboto_Mono'] text-[14px] font-medium text-sm border-t border-b border-solid border-bordercolor">
              Destination
            </th>
            <th className="p-3 whitespace-nowrap text-center align-middle text-black font-['Roboto_Mono'] text-[14px] font-medium text-sm border-t border-b border-solid border-bordercolor">
              Climate
            </th>
            <th className="p-3 text-center align-middle text-black font-['Roboto_Mono'] text-[14px] font-medium text-sm w-20 border-t border-b border-solid border-bordercolor">
              Duration
            </th>
            <th className="p-3 whitespace-nowrap text-center align-middle text-black font-['Roboto_Mono'] text-[14px] font-medium text-sm border-t border-b border-solid border-bordercolor">
              Body Type
            </th>
            <th className="p-3 whitespace-nowrap text-center align-middle text-black font-['Roboto_Mono'] text-[14px] font-medium text-sm border-t border-b border-solid border-bordercolor">
              Packing Style
            </th>
            <th className="p-3 text-center align-middle text-black font-['Roboto_Mono'] text-[14px] font-medium text-sm w-20 border-t border-b border-solid border-bordercolor">
              Tags
            </th>
            <th className="p-3 text-center align-middle text-black font-['Roboto_Mono'] text-[14px] font-medium text-sm w-20 border-t border-b border-solid border-bordercolor">
              Actions
            </th>
          </tr>
        </thead>
        <tbody className="bg-white">
          {loading ? (
            <></>
          ) : (
            data?.data?.map((items, index) => (
              <tr
                key={index}
                className="bg-white hover:bg-tablecolor rounded-xl"
              >
                <td className="p-3 text-center align-middle rounded-l-xl border-l border-t border-b border-solid border-bordercolor">
                  <input
                    type="checkbox"
                    className="rounded border-normalGray"
                  />
                </td>
                <td className="p-3 text-center align-middle text-normalGray border-t border-b border-solid font-quicksand text-sm font-semibold border-bordercolor">
                  {items?._id}
                </td>
                <td className="p-3 text-center align-middle text-normalGray border-t border-b border-solid font-quicksand text-sm font-semibold border-bordercolor">
                  {items?.title}
                </td>
                <td className="py-2 px-3 text-center align-middle border-t border-b border-solid border-bordercolor">
                  <span
                    className={`block w-fit py-[2px] px-2 rounded-md ${items.type === "PRO"
                      ? "bg-[#D9DCB0] text-black font-semibold text-sm"
                      : "bg-gray-200 text-gray-600 font-semibold text-sm"
                      }`}
                  >
                    {items?.type}
                  </span>
                </td>
                <td className="p-3 text-center align-middle text-black font-quicksand text-[12px] font-semibold text-sm border-t border-b border-solid border-bordercolor">
                  {items?.destinations?.map((dest, idx) => (
                    <span key={idx} className="items-center">
                      {dest?.region} {dest?.country} {dest?.state} {dest?.city},{" "}
                    </span>
                  ))}
                </td>
                <td className="p-3 text-center align-middle text-normalGray font-quicksand text-sm font-semibold border-t border-b border-solid border-bordercolor">
                  {items?.climate?.map((item, index) => (
                    <span key={index}>{item?.climateType}, </span>
                  ))}
                </td>
                <td className="p-3 text-center align-middle text-normalGray font-quicksand text-sm font-semibold border-t border-b border-solid border-bordercolor">
                  {items?.duration}
                </td>
                <td className="p-3 text-center align-middle text-normalGray font-quicksand text-sm font-semibold border-t border-b border-solid border-bordercolor">
                  {items?.bodyType}
                </td>
                <td className="p-3 text-center align-middle text-normalGray font-quicksand text-sm font-semibold border-t border-b border-solid border-bordercolor">
                  {items?.packingStyle}
                </td>
                <td
                  className={`p-3 text-center align-middle text-normalGray font-quicksand text-sm font-semibold border-t border-b border-solid border-bordercolor`}
                >
                  <span
                    className={`p-2 rounded-md whitespace-nowrap ${items?.isBlocked
                      ? "bg-errorcolor text-white"
                      : items?.status == "PUBLISHED" ? "bg-bgprimary text-dark" : "bg-[#ffde59] text-dark"
                      }`}
                  >
                    {items?.isBlocked ? "Block" : items?.status == "PUBLISHED" ? "PUBLISHED" : "On Hold"}
                  </span>
                </td>
                <td className="p-3 text-center align-middle rounded-r-xl border-r border-t border-b border-solid border-bordercolor">
                  <Dropdown
                    active={dropdownActive === index}
                    onClick={(e) => {
                      e.stopPropagation();
                      toggleDropdown(index);
                    }}
                    options={[
                      {
                        label: "View",
                        onClick: (e) => {
                          e.stopPropagation();
                          navigate(`/trip-detail/${items?._id}`);
                        },
                      },
                      {
                        label: items?.isBlocked ? "Unblock" : "Block",
                        onClick: (e) => {
                          e.stopPropagation();
                          handleBlockPacking(items?._id, "6months");
                          toggleDropdown(index);
                        },
                      },
                      {
                        label: items?.status == "PUBLISHED" ? "Unpublish" : "Publish",
                        onClick: (e) => {
                          e.stopPropagation();
                          handleStatusPacking(items?._id, items?.status == "PUBLISHED" ? "NOT_PUBLISHED" : "PUBLISHED");
                          toggleDropdown(index);
                        },
                      },

                      {
                        label: "Update",
                        onClick: (e) => {
                          e.stopPropagation();
                          navigate(`/editpackinglist/${items?._id}`)
                        },
                      },

                      {
                        label: "duplicate",
                        onClick: (e) => {
                          e.stopPropagation();
                          handleDuplicatePacking(items?._id);
                          toggleDropdown(index);
                        },
                      },
                      {
                        label: "Delete",
                        onClick: (e) => {
                          e.stopPropagation();
                          updateListState({
                            selectedDeleteItem: items?._id,
                            isDeleteModalOpen: true,
                          })
                          // setSelectedDeleteItem(items?._id);
                          // setIsDeleteModalOpen(true);
                          toggleDropdown(index);
                        },
                      },
                    ]}
                  />
                </td>
              </tr>
            ))
          )}
        </tbody>
      </table>

      {loading && (
        <div className="relative h-[30vh] w-full">
          <LoaderSpiner />
        </div>
      )}

      {packingList?.isUpdateModalOpen && (
        <UpdatePopup item={packingList?.selectedItem} onClose={closeUpdatePopup} />
      )}

      {packingList?.isDeleteModalOpen && (
        <div className="fixed inset-0 flex items-center justify-center bg-opacity-50 bg-black z-50">
          <div className="text-center bg-white rounded-lg p-6 w-[20rem] shadow-lg relative">
            <p className="mb-4">Are you sure you want to delete this item?</p>
            <button
              className="bg-errorcolor text-white px-4 py-2 rounded mr-2"
              onClick={() => handleDeletePacking(packingList.selectedDeleteItem && packingList.selectedDeleteItem)}
            >
              {isLoadingDelete ? 'Deleting...' : 'Delete'}
            </button>
            <button
              className="bg-gray-300 px-4 py-2 rounded"
              onClick={closeDeletePopup}
            >
              Cancel
            </button>
          </div>
        </div>
      )}
    </div>
  );
}

